import React from "react";
import "./ExamPrep.css";

const B2ExamPrep = () => {
  return (
    <div className="a1ExamPrepCover">
      <h3>
        Goethe <span>B2 Exam</span> Preparation
      </h3>
      <p>
        German B2 is the upper intermediate level. To prepare for the Goethe B2:
      </p>
      <ul>
        <li>
          Expand your vocabulary and deepen your understanding of complex
          grammar structures. Practice reading a variety of texts, such as long
          articles, literary works, or professional documents.
        </li>
        <li>Work on writing essays or formal letters.</li>
        <li>
          Practice speaking German through discussions, debates, and
          presentations to express yourself confidently.
        </li>
      </ul>
    </div>
  );
};

export default B2ExamPrep;
